import { observer } from 'mobx-react-lite';
import { useResolve } from '@/infrastructure/useResolve';
import { TOKEN_ToastStore } from './ToastStore';

const kindClass: Record<string, string> = {
  success: 'border-emerald-300 bg-emerald-50 text-emerald-900',
  error: 'border-rose-300 bg-rose-50 text-rose-900',
  info: 'border-slate-300 bg-white text-slate-900',
};

export const ToastView = observer(function ToastView() {
  const store = useResolve(TOKEN_ToastStore);
  if (store.toasts.length === 0) return null;
  return (
    <div className="pointer-events-none fixed bottom-4 right-4 flex flex-col gap-2">
      {store.toasts.map((t) => (
        <div
          key={t.id}
          className={`pointer-events-auto min-w-[200px] rounded border px-3 py-2 text-sm shadow ${kindClass[t.kind]}`}
        >
          <button
            type="button"
            onClick={() => store.dismiss(t.id)}
            className="float-right ml-3 text-xs opacity-60 hover:opacity-100"
          >
            ✕
          </button>
          {t.message}
        </div>
      ))}
    </div>
  );
});
